<template>
  <div class="p-5 space-y-4">
    <ConditionBased class="space-y-4" />
  </div>
</template>

<script setup lang="ts">
import ConditionBased from "./ConditionBased/ConditionBased.vue";
</script>
